export interface Theme {
  medicalBlue: string
  medicalBlueHover: string
  medicalRed: string
  sfBlack: string
  verticalModeThreshold: number
  pink: string
  babyBlue: string
}

export const theme = {
  medicalBlue: '#4867d6',
  medicalBlueHover: '#728BE4',
  medicalRed: 'red',
  sfBlack: '#555555',
  verticalModeThreshold: 1064,
  pink: '#fbadb0',
  babyBlue: '#adcce9'
}
